import { defaultParamsFilter, dataConfigTable } from "./state";

/**
 * Mutación para restablecer los datos iniciales del filtro.
 *
 * @param {*} state
 * @author Fernando Claros
 */
export function resetDataFilter(state) {
    state.filter = defaultParamsFilter()
}

/**
 * Mutación manipular/alterar los datos del filtro.
 *
 * @param {*} state
 * @param {*} nextState
 * @author Fernando Claros
 */
export function setDataFilter(state, nextState) {
    state.filter = nextState
}

/**
 * Mutación manipular/alterar el estado de si los datos de la tabla están cargando o no.
 *
 * @param {*} state
 * @param {*} nextState
 * @author Fernando Claros
 */
export function setLoadingDataTable(state, nextState) {
    state.loadingDataTable = nextState
}

/**
 * Mutación manipular/alterar el estado de si se está descargando el reporte.
 *
 * @param {*} state
 * @param {*} nextState
 * @author Fernando Claros
 */
export function setLoadingDownloadReport(state, nextState) {
    state.loadingDownloadReport = nextState
}

/**
 * Mutación manipular/alterar la información de la tabla de tanques.
 *
 * @param {*} state
 * @param {*} nextState
 * @author Fernando Claros
 */
export function setTableConfig(state, nextState) {

    const { data, items } = nextState;

    state.tableConfig.data = data;
    if (items && typeof items === 'object') state.tableConfig.items = items;
}

/**
 * Mutación para resetear la información de la tabla de tanques.
 *
 * @param {*} state
 * @author Fernando Claros
 */
export function resetTableConfig(state) {
    state.tableConfig = dataConfigTable()
}

/**
 * Mutación manipular/alterar el estado del filtro ítems por pagina.
 *
 * @param {*} state
 * @param {*} nextState
 * @author Fernando Claros
 */
export function setPerPagePagination(state, nextState) {
    state.filter = { ...state.filter, per_page: nextState }
}

/**
 * Mutación manipular/alterar el estado del filtro página de la paginación.
 *
 * @param {*} state
 * @param {*} nextState
 * @author Fernando Claros
 */
export function setPagePagination(state, nextState) {
    state.filter = { ...state.filter, page: nextState }
}